import { render } from "./BusinessDetailsForm.vue?vue&type=template&id=2bd2a359&ts=true"
import script from "./BusinessDetailsForm.vue?vue&type=script&lang=ts"
export * from "./BusinessDetailsForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__